import { render, staticRenderFns } from "./Giin.vue?vue&type=template&id=2d7f4f6a"
import script from "./Giin.vue?vue&type=script&lang=ts"
export * from "./Giin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports